import React from 'react';
import { MainContent } from '../../utilities/mainContent';
import TableData from '../../utilities/table';
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
  // Drawer,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuButtons } from '../../utilities/menuButton';
import { DialogBox } from '../../utilities/dialog';
import { Add } from './add';
import UserServices from '../../../service/user';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DeleteContent } from '../../../hooks/utils';

const items = [
  {
    label: 'View role',
    icon: <EditIcon fontSize='small' />,
  },
  {
    label: 'Delete role',
    icon: <DeleteIcon fontSize='small' />,
  },
];

const csvCol = [
  {
    key: 'name',
    label: 'Name',
  },
];
export const GroupComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [filtered, setFiltered] = React.useState(null);
  const [group, setGroup] = React.useState(null);

  const [isDelete, setIsDelete] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const { data, isLoading } = useQuery({
    queryKey: ['groups_data'],
    queryFn: () => UserServices.getAllGroup(),
  });
  const handleClose = () => {
    setAnchorEl(null);
  };

  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: UserServices.deleteGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['groups_data'] });
      setIsDelete(false);
    },
  });

  const handleMenuItem = (item) => {
    if (item.label === 'View role') {
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === 'Delete role') {
      setAnchorEl(null);
      setIsDelete(true);
    } else {
      return null;
    }
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 700,
    },

    {
      field: '',
      headerName: '',
      width: 340,
      renderCell: () => {
        return (
          <Grid container justifyContent='flex-end'>
            <IconButton
              aria-controls={open ? 'fade-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <MenuButtons
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              items={items.map((item, index) => (
                <MenuItem key={index} onClick={() => handleMenuItem(item)}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography variant='subtitle2'>{item.label}</Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            />
          </Grid>
        );
      },
    },
  ];

  return (
    <>
      <MainContent
        csvData={data}
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        fileNameWithFilter={'User role list'}
        fileName={'User role list'}
        valueFrom={'add_group'}
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || '';
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) => item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          );
          setFiltered(() => value);
        }}
        items={
          <TableData
            cols={columns}
            rows={filtered || data}
            maxWidthMob='84vw'
            height='400px'
            isLoading={isLoading}
            onRowClick={({ row }) => setGroup(() => row)}
          />
        }
        isBtnName={true}
        btnName={'Add'}
        onBtnNameClick={() => {
          setGroup(() => null);
          setIsDialog(() => true);
        }}
      />
      <DialogBox
        handleClose={() => setIsDialog(() => false)}
        open={isDialog}
        title={
          <Typography variant='subtitle1' component='span'>
            Role
          </Typography>
        }
        content={
          <Add
            maxWidth={'700px'}
            label_name='Role'
            handleClose={() => setIsDialog(() => false)}
            group={group}
            mutationFn={
              group ? UserServices.updateGroup : UserServices.addGroup
            }
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(() => false)}
        open={isDelete}
        maxWidth='500px'
        title={
          <Typography variant='subtitle1' component='span'>
            Delete Role
          </Typography>
        }
        content={
          <DeleteContent
            title='Are you sure you want to delete this role?'
            onCancel={() => setIsDelete(() => false)}
            onSubmit={() => {
              const id = group.id;
              const method = 'delete';
              mutate({ id, method });
            }}
          />
        }
      />
    </>
  );
};
